/* global dataLayer */
/* global Vue */
import axios from 'axios';
import moment from 'moment';
import router from '../router';
import storejs from 'store';
import _ from 'lodash';
import { encodeURI } from 'js-base64';

import {
  dynamicPHPPath,
} from '@utilities';

import {
  PLAYPOSIT_API_ENDPOINTS,
} from '@Constants';

const phpApiPrefix = dynamicPHPPath(window.location.hostname);

//Learners specicific state
const state = {
  //learner nav state
  activeViewLearners:'Classes',
  learnerGradebookBreadcrumbs: [],

  //boolean toggles for data
  learnersAjaxing: false,
  learnerDataLoaded: true,
  learnerSectionPlaylists: null,
  refreshData: false,

  //interaction learner data
  selectedData: [],
  queryParamsLearners: {
    page: 1,
    per_page: 20,
    search: '',
    sort: '',
    section_id: '',
    bulb_id: '',
    lmb_bulb: '',
    lmb_section: '',
    lms_launch: false,
  },
  //table data
  classes: {
    pagination: {
        total: 0,
        rowsPerPage: [],
    },
    data: [],
  },
  bulbs: {
    pagination: {
        total: 0,
        rowsPerPage: [],
    },
    data: [],
  },
  gradebook: {
    pagination: {
      total: 0,
      rowsPerPage: [],
    },
    data: [],
  },
  studentinteraction: {
    pagination: {
      total: 0,
      rowsPerPage: [],
    },
    data: [],
   },
   playlists: {},
   learnerSectionHasPlaylist: false,
   lmb: {
    pagination: {
      total: 0,
      rowsPerPage: [],
    },
    headers:[],
    data: [],
   },
  peerReview: {
    give: [],
    view: [],
    instructor: [],
    discussion: {},
    interactions: [],
  },
  peerReviewRubric: {
    give: [],
    view: [],
    instructor: [],
    discussion: {},
    interactions: [],
  },
  //popup data
  classSearch: [],
  classPicker: {
    loaded: false,
    data: []
  },
  attemptGetPlaylists: false,
  initialSectionId: null, // Used to store a sectionId from PHP to auto load a class
}

const mutations = {
    //nav mutations
    setActiveView(state, array){
      //set learner active view
      let activeView = array[0];
      state.activeViewLearners= activeView;
    },
    setAttemptGetPlaylists(state, value) {
      state.attemptGetPlaylists = value;
    },
    setGradebookBreadcrumbs(state, breadcrumbs) {
      //set gradebook breadcrumbs
      state.learnerGradebookBreadcrumbs= breadcrumbs
    },
    setLearnerSectionPlaylists(state, playlists) {
      state.learnerSectionPlaylists = playlists;
    },
    //interactive data mutations
    setQueryParams(state, object){
      //merge original and new query params
      let queryParams = state.queryParamsLearners;
      let newParams = Object.assign(queryParams, object);
      //set query params to state
      state.queryParamsLearners = newParams;
    },
    resetQueryParams(state){
      //reset learner query params
      let lms_launch = state.queryParamsLearners.lms_launch;

      state.queryParamsLearners = {
        page: 1,
        per_page: 20,
        search: '',
        sort: '',
        section_id: '',
        bulb_id: '',
        lmb_bulb: '',
        lmb_section: '',
        lms_launch: lms_launch
      }
    },

    //mutations to set table data
    setTableData(state, object) {
      //sets table data based on activeView
      switch (object.route) {
        case 'classes':
          //sets class data and pagination
          state.classes.pagination = {
            total : object.data.total,
          };
          state.classes.data = object.data.data;
          state.learnerDataLoaded = true;
          break;
        case 'bulbs':
          // There are no bulbs in the class and we this is the initial learnerDash load - attempt to get playlists.
          if (
            !object.data.data.length
            && !state.attemptGetPlaylists
          ) state.attemptGetPlaylists = true;
          else {
            // Guess the student's timezone:
            let tz = moment.tz.guess();
            // Parse status of bulb attempt
            object.data.data.map( (item) => {
              // The bulb's assigned date comes back in UTC format so we need to convert it to the students timezone:
              item.assigned_date = moment.tz(item.assigned_date, tz).format("MMM DD, YYYY hh:mm A z");
              if (!item.complete && item.complete != 0) {
                item.status = 'Not Started';
              } else if (item.complete === 1) {
                item.status = `Completed on ${moment(item.completion_time).format("MMM DD, YYYY LT")}`;
              } else if (item.complete === 0) {
                item.status = 'In Progress';
              }
            });
            state.bulbs = object.data;
            state.learnerDataLoaded = true;
          }
          break;
        case 'gradebook':
          //sets learner gradebook data and pagination
          state.gradebook.pagination = {
            total : object.data.total,
          };
          //parse attempt date
          object.data.data.map(item => {
            if (item.complete === 0){
              item.completion_time = 'In Progress';
            } else {
              if (item.completion_time) item.completion_time = moment(item.completion_time).format("MMM DD, YYYY LT");
            }
          })

          state.gradebook.data = object.data.data;
          state.learnerDataLoaded = true;
          break;
        case 'studentinteraction':
          //sets student interaction data for bulb id and pagination
          state.studentinteraction.pagination = {
            total : object.data.total,
          };
          state.studentinteraction.data = object.data.data;
          state.learnerDataLoaded = true;
          break;
        case 'lmb':
          //sets interaction data and pagination
          state.lmb.pagination = {
            total : object.data.total,
          };
          state.lmb.headers = object.data.headers;
          //parse status of bulb attempt
          object.data.data.map(item => {
            if(!item.complete && item.complete !=0){
              item.status = 'Not Started';
            } else if(item.complete === 1) {
              item.status = 'Completed';
            } else if (item.complete === 0) {
              item.status = 'In Progress';
            }
          })

          state.lmb.data = object.data.data;

          state.dynamicDataLoaded = true;
          break;
        case 'playlists':
          state.playlists = object.data;
          if (object.data.data.length > 0) state.learnerSectionHasPlaylist = true;
          else state.learnerSectionHasPlaylist = false;
          state.learnerSectionPlaylists = object.data.data;
          state.learnerDataLoaded = true;
          break;
        default:
          break;
      }
    },

    //boolean toggle mutations
    refreshData(state){
      //trigger data refresh
      state.refreshData = true;
    },
    refreshComplete(state){
      //trigger data refresh is completed
      state.refreshData = false;
    },

    //mutations for popup data
    setSearchClass(state, data){
      //sets class search data
      state.classSearch.push(data.data.data);
    },
    resetClassSearch(state){
      //resets the class search data
      state.classSearch = [];
    },
    setClassPicker(state, data){
      state.classPicker.data = data.data;
      state.classPicker.loaded = true;
    },
    setPeerReview(state, obj) { 
      // LTI way of setting peer review 
      // data object specifically for learner popover, should be merged with peerReviewRubric
      if(obj.type === 'feedback'){
        obj.data.student.map(item => {
          if(item.complete === null){
            item.status = 'Waiting for feedback'
          } else if(item.complete === 0){
            item.status = 'In Progress'
          } else {
            item.status = `Completed on ${moment(obj.data.completion_time).format('MMM DD, YYYY')}`
          }
          return item;
        })

        state.peerReview.view = obj.data.student;

        obj.data.teacher.map(item => {
          if(item.complete === null){
            item.status = 'Waiting for feedback'
          } else if(item.complete === 0){
            item.status = 'In Progress'
          } else {
            item.status = `Completed on ${moment(obj.data.completion_time).format('MMM DD, YYYY')}`
          }
          return item;
        })

        state.peerReview.instructor = obj.data.teacher;

        //set discussion data
        obj.data.interactions.forEach(item => {
          if(item.interactionType === 'discussion_q'){
            state.peerReview.discussion = {id:item.id, text: item.interactionText};
          }
        })

        state.peerReview.interactions = obj.data.interactions;
      }
    },
    setPeerReviewRubric(state, obj){
      // data object specifically for instructor slideout, should be merged with peerReview 
      if(obj.type === 'feedback'){
        obj.data.student.map(item => {
          if(item.complete === null){
            item.status = 'Waiting for feedback'
          } else if(item.complete === 0){
            item.status = 'In Progress'
          } else {
            item.status = `Completed on ${moment(obj.data.completion_time).format('MMM DD, YYYY')}`
          }
          return item;
        })

        state.peerReviewRubric.view = obj.data.student;

        obj.data.teacher.map(item => {
          if(item.complete === null){
            item.status = 'Waiting for feedback'
          } else if(item.complete === 0){
            item.status = 'In Progress'
          } else {
            item.status = `Completed on ${moment(obj.data.completion_time).format('MMM DD, YYYY')}`
          }
          return item;
        })

        state.peerReviewRubric.instructor = obj.data.teacher;
        //set discussion data
        obj.data.interactions.forEach(item => {
          if(item.interactionType === 'discussion_q'){
            state.peerReviewRubric.discussion = {id:item.id, text: item.interactionText};
          }
        })

        state.peerReviewRubric.interactions = obj.data.interactions;
      }
    },
    setLearnerSectionHasPlaylist(state, value) {
      state.learnerSectionHasPlaylist = value;
    },
  setInitialSectionId(state, value) {
    state.initialSectionId = value;
  },
}

const actions = {
    updateUrl: ({state, rootState}) => {
        // updates the url on changes to table including activeView and all query params

        router.push({name: 'learner',
        params:{activeView:rootState.activeView, secondaryView:state.activeViewLearners},
        query:{
            page: state.queryParamsLearners.page,
            per_page: state.queryParamsLearners.per_page,
            search: state.queryParamsLearners.search,
            sort: state.queryParamsLearners.sort,
            section_id: state.queryParamsLearners.section_id,
            bulb_id: state.queryParamsLearners.bulb_id,
            lmb_bulb: state.queryParamsLearners.lmb_bulb,
            lmb_section: state.queryParamsLearners.lmb_section,
            lms_launch: state.queryParamsLearners.lms_launch,
            breadcrumbs: encodeURI(JSON.stringify(rootState.breadcrumbs)),
            gradebook: encodeURI(JSON.stringify(state.learnerGradebookBreadcrumbs)),
        }});
        //set array to blank array, find data from storejs if available
        let array = []
        if(storejs.get('url')){
          array = storejs.get('url');
        }

        array.push({path:router.history.current.fullPath,  data:{name: 'learner',
        params:{activeView:rootState.activeView, secondaryView:state.activeViewLearners},
        query:{
            page: state.queryParamsLearners.page,
            per_page: state.queryParamsLearners.per_page,
            search: state.queryParamsLearners.search,
            sort: state.queryParamsLearners.sort,
            section_id: state.queryParamsLearners.section_id,
            bulb_id: state.queryParamsLearners.bulb_id,
            lmb_bulb: state.queryParamsLearners.lmb_bulb,
            lmb_section: state.queryParamsLearners.lmb_section,
            lms_launch: state.queryParamsLearners.lms_launch,
            breadcrumbs: encodeURI(JSON.stringify(rootState.breadcrumbs)),
            gradebook: encodeURI(JSON.stringify(state.learnerGradebookBreadcrumbs)),
        }}})
        storejs.set('url', array);
    },

    //Data call for Table Component
    getTableData: ({commit, state, rootState}) => {
      //route determined by active view
      let route,endpoint;
      switch (state.activeViewLearners) {
        case 'Classes':
              route = 'classes'
              endpoint = route
              break;
        case 'Bulbs':
              route = 'bulbs'
              endpoint = `section/${state.queryParamsLearners.section_id}/bulbs`
              break;
        case 'Gradebook':
              route = 'gradebook'
              endpoint = `classes/${state.queryParamsLearners.section_id}/bulbattempts`
              break;
        case 'Student-Interaction':
              route = 'studentinteraction'
              endpoint = `classes/${state.queryParamsLearners.section_id}/bulbs/${state.queryParamsLearners.bulb_id}/interactionattempts`
              break;
        case 'Playlists':
          route = 'playlists';
          endpoint = `section/${state.queryParamsLearners.section_id}/playlist`;
          break;
        default:
            console.log("Error: Please add route to learners getTableData switch function");
            break;
      }
      //data call for table component based on activeView
      if(!state.learnersAjaxing){
        //turns on ajaxing and resets data loading variable
        state.learnersAjaxing = true;
        state.learnerDataLoaded = false;

        let timestamp = moment();
        //get table data
        axios.get(`${rootState.nodeApiPrefix}/learner/${endpoint}?page=${state.queryParamsLearners.page}&per_page=${state.queryParamsLearners.per_page}&search=${state.queryParamsLearners.search}&sort=${state.queryParamsLearners.sort}&bulb_id=${state.queryParamsLearners.bulb_id}&section_id=${state.queryParamsLearners.section_id}&timestamp=${timestamp}` , {headers:{'Authorization':`Bearer ${rootState.learnerData.token}`}})
        .then(res => {
          //if success, set table data and turn off ajaxing
          if(res.data.msg === "success") commit('setTableData', {data: res.data.data, route: route});
          state.learnersAjaxing = false;
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
          console.error(err);
          dataLayer.axiosLog(err);
          commit('triggerSnackbar', {text:`${state.activeViewLearners} data cannot load at this time`, color: 'red', timeout: 6000} , {root:true});
          state.learnersAjaxing = false;
          state.learnerDataLoaded = true;
        });
      }
    },
    getMonitorData: ({commit, state, rootState}) => {
      if(!state.learnersAjaxing){
        //turn on ajax boolean
        state.learnersAjaxing = true;
        state.learnerDataLoaded = false;
        let timestamp = moment();
        //post section id
        axios.get(`${rootState.nodeApiPrefix}/instructor/classes/${state.queryParamsLearners.lmb_section}/bulbs/${state.queryParamsLearners.lmb_bulb}/interactionattempts?page=${state.queryParamsLearners.page}&per_page=${state.queryParamsLearners.per_page}&search=${state.queryParamsLearners.search}&sort=${state.queryParamsLearners.sort}&bulb_id=${state.queryParamsLearners.lmb_bulb}&section_id=${state.queryParamsLearners.lmb_section}&timestamp=${timestamp}` , {headers:{'Authorization':`Bearer ${rootState.instructorData.token}`}})
        .then(res => {
            //if success, trigger refresh and turn off ajaxing
            if(res.data.msg === "success") {
              commit('setTableData', {data: res.data.data, route: 'lmb'});
              state.learnersAjaxing  = false;
              state.learnerDataLoaded = true;
            }
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
            console.error(err);
            dataLayer.axiosLog(err);
            commit('triggerSnackbar', {text:"Getting Learner Made Bulb Monitor Data did not work at this time.", color: 'red', timeout: 6000} , {root:true});
            state.learnersAjaxing  = false;
            state.learnerDataLoaded = true;
        });
      }
    },
    async getGoogleAuthURL({commit, rootState}, redirectURL) {
      try {
        return await axios.post(`${rootState.nodeApiPrefix}/google-classroom/authurl`,
        {
          redirectURL,
          learner: true,
        },
        {
          headers: { 'Authorization':`Bearer ${rootState.learnerData.token}` }
        });
      } catch (e) {
        commit('triggerSnackbar', {
          text: 'Error getting auth URL.',
          color: 'error',
        }, {root:true});
      }
    },
    async getStudentGoogleToken({commit, rootState}, data) {
      return await axios.get(`${rootState.nodeApiPrefix}/google-classroom/student-auth?code=${data.code}`,
        {
          headers: { 'Authorization':`Bearer ${rootState.learnerData.token}` }
        });
    },
    removeClass: ({commit, state, rootState}, id) => {
      if(!state.learnersAjaxing){
        //turn on ajax boolean
        state.learnersAjaxing = true;

      //set data to section id
      let data = {section_id: id}
      //post section id
      axios.delete(`${rootState.nodeApiPrefix}/learner/classes/${data.section_id}`, {headers:{'Authorization':`Bearer ${rootState.learnerData.token}`}})
        .then(res => {
            //if success, trigger refresh and turn off ajaxing
            if(res.data.msg === "success") {
              state.refreshData = true;
              state.learnersAjaxing  = false;
            }
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
            console.error(err);
            dataLayer.axiosLog(err);
            commit('triggerSnackbar', {text:"Removing class did not work at this time", color: 'red', timeout: 6000} , {root:true});
            state.learnersAjaxing  = false;
        });
      }
    },
    //Data call to search for class matching the class-code
    searchClass: ({commit, state, rootState}, array) => {
      //sets teacher id and section id from array
      let teacher_id = array[0]
      let section_id = array[1]

      if(!state.learnersAjaxing && teacher_id && section_id){

        let timestamp = moment();
        //if variables set, turn on ajaxing
        state.learnersAjaxing = true;
        //reset class search data
        state.classSearch = [];
        //get class data
        axios.get(`${rootState.nodeApiPrefix}/learner/classes/${section_id}?teacher_id=${teacher_id}&timestamp=${timestamp}`, {headers:{'Authorization':`Bearer ${rootState.learnerData.token}`}})
        .then(res => {
          //if success, set class search data and turn off ajaxing
          if(res.data.msg === "success") commit('setSearchClass', {data: res.data.data});
          state.learnersAjaxing = false;
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
          console.error(err);
          dataLayer.axiosLog(err);
          commit('triggerSnackbar', {text:"Searching class code not working at this time", color: 'red', timeout: 6000} , {root:true});
          state.learnersAjaxing = false;
        });
      }
    },
    //Data call to join class
    joinClass: ({commit, state, rootState}) => {

      if(!state.learnersAjaxing){

        let timestamp = moment();
        //turn on ajax boolean
        state.learnersAjaxing = true;

        let postdata = {
          timestamp: timestamp
        }

        //post section id
        axios.post(`${rootState.nodeApiPrefix}/learner/classes/${state.classSearch[0].section_id}`, postdata, {headers:{'Authorization':`Bearer ${rootState.learnerData.token}`}})
        .then(res => {
          if(res.data.msg === "success"){
            //if success, trigger refresh, reset class search data, close modal, and turn off ajaxing
            state.refreshData = true;
            state.classSearch = [];
            rootState.dialogShow.dash = false;
            rootState.popoverToggles.joinClass = false;
            state.learnersAjaxing = false;
          }
        }).catch(err => {
          //if error, log error, trigger snackbar, reset selected data and turn off ajaxing
          console.error(err);
          dataLayer.axiosLog(err);
          state.classSearch = [];
          rootState.dialogShow.dash = false;
          rootState.popoverToggles.joinClass = false;
          commit('triggerSnackbar', {text:"Searching class code not working at this time", color: 'red', timeout: 6000} , {root:true});
          state.learnersAjaxing = false;
        });
      }
    },
    saveProfile: ({commit, state, rootState}, data) => {
      if(!state.learnersAjaxing){
        //turn on ajax boolean
        state.learnersAjaxing = true;
      //post profile data
      axios.post(`${rootState.nodeApiPrefix}/learner/me`, data, {headers:{'Authorization':`Bearer ${rootState.learnerData.token}`}})
        .then(res => {
            if(res.data.msg === "success") {
              //if success, close modal, turn off ajaxing, and reset username/initials
              state.learnersAjaxing  = false;
              rootState.dialogShow.dash = false;
              rootState.popoverToggles.profile = false;
              if(res.data.data.data[0] === 1){
                rootState.username = `${data.first_name} ${data.last_name}`;
                rootState.learnerData.avatarInitials = `${data.first_name[0]} ${data.last_name[0]}`
              }
            }
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
            console.error(err);
            dataLayer.axiosLog(err);
            rootState.dialogShow.dash = false;
            rootState.popoverToggles.profile = false;
            commit('triggerSnackbar', {text:"Saving profile data not working at this time.", color: 'red', timeout: 6000} , {root:true});
            state.learnersAjaxing  = false;
        });
      }
    },
    deleteAccount: ({commit, state, rootState}, data) => {
      if(!state.learnersAjaxing){
        //turn on ajax boolean
        state.learnersAjaxing = true;
      //post delete account request
      axios.delete(`${rootState.nodeApiPrefix}/learner/me`, {headers:{'Authorization':`Bearer ${rootState.learnerData.token}`}})
        .then(res => {
            if(res.data.msg === "success") {
              //if success, turn off ajaxing and replace window with playposit learn
              state.learnersAjaxing  = false;
              storejs.clearAll();
              window.location.replace(`${phpApiPrefix}/logout`);
            }
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
            console.error(err);
            dataLayer.axiosLog(err);
            commit('triggerSnackbar', {text:"Deleting account did not work at this time", color: 'red', timeout: 6000} , {root:true});
            state.learnersAjaxing  = false;
        });
      }
    },
    reactivateAccount: ({dispatch, commit, state, rootState}, data) => {
      if(!state.learnersAjaxing){
        //turn on ajax boolean
        state.learnersAjaxing = true;
      //post request to reactivate account
      axios.put(`${rootState.nodeApiPrefix}/learner/me`, {}, {headers:{'Authorization':`Bearer ${rootState.learnerData.token}`}})
        .then(res => {
            if(res.data.msg === "success") {
              //if success, turn off ajaxing and archived student flag
              state.learnersAjaxing  = false;
              commit('simpleDashToggle', {activate: false} , {root:true});
            }
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
            console.error(err);
            dataLayer.axiosLog(err);
            commit('triggerSnackbar', {text:"Reactivating account did not work at this time", color: 'red', timeout: 6000} , {root:true});
            state.learnersAjaxing  = false;
        });
      }
    },
    //Data call to search for class matching the class-code
    getClassPicker: ({commit, state, rootState}, array) => {
      //sets teacher id and section id from array
      let bulb_id = array[0]
      let teacher_id = array[1]
      let token = array[2]

      //get class data
      axios.get(`${rootState.nodeApiPrefix}/learner/bulbs/${bulb_id}/classes?teacher_id=${teacher_id}`, {headers:{'Authorization':`Bearer ${token}`}})
      .then(res => {
        //if success, set class search data and turn off ajaxing
        if(res.data.msg === "success") commit('setClassPicker',  res.data);
      }).catch(err => {
        //if error, log error, trigger snackbar and turn off ajaxing
        console.error(err);
        dataLayer.axiosLog(err);
        commit('triggerSnackbar', {text:"Classes cannot be loaded at this time", color: 'red', timeout: 6000} , {root:true});
      })
    },
    //Data call to search for class matching the class-code
    createLMB: ({commit, state, rootState}, obj) => {
      if (!state.learnersAjaxing) {
        state.learnersAjaxing = true;
        let postdata = {
          student_teacher_id: _.get(rootState, 'instructorData.id', null),
          resource_link_id: _.get(obj, 'resource_link_id', ''),
        }
        axios.post(`${rootState.nodeApiPrefix}/learner/classes/${obj.section_id}/bulbs/${obj.id}/learnermade`, postdata, {headers:{'Authorization':`Bearer ${rootState.learnerData.token}`}})
        .then(res => {
          //if success, set class search data and turn off ajaxing
          if(res.data.msg === "success") {
            state.refreshData = true;
            let data = rootState.LTIlaunch ? storejs.get('lti-student') : rootState.simpleDashData; // lmb simpleDashData matches lti-student data on lti launch
            data.bulbAttemptId = res.data.data.bulbAttempt
            data.lmb_id = res.data.data.bulb;
            data.lmb_section_id = res.data.data.section_id;
            if (rootState.LTIlaunch) {
              storejs.set('lti-student', data);
              commit('simpleDashToggle', { activate:true, type: 'lmb', data }, { root: true });
              commit('simpleDashReloadToggle', true, { root: true } )
            }
            
            if (res.data.teacherData.token) {
              commit('setTeacherData', res.data.teacherData, { root:true });
              window.open(`${rootState.designerApiPrefix}/designer/?bulb_id=${res.data.data.bulb}&section_id=${obj.section_id}&token=${res.data.teacherData.token}${!!obj?.issuer ? `&issuer=${obj.issuer}` : ''}${obj?.lti13Launch ? `&lti13Launch=${true}` : ''}`);
            } else {
              window.open(`${rootState.designerApiPrefix}/designer/?bulb_id=${res.data.data.bulb}&section_id=${obj.section_id}&token=${rootState.instructorData.token}${!!obj?.issuer ? `&issuer=${obj.issuer}` : ''}${obj?.lti13Launch ? `&lti13Launch=${true}` : ''}`);
            }
            state.learnersAjaxing = false;
          }
        }).catch(err => {
          //if error, log error, trigger snackbar and turn off ajaxing
          state.learnersAjaxing = false;
          console.error(err);
          dataLayer.errorLog(err.response);
          commit('triggerSnackbar', { text: "Error creating Learner Made Bulb", color: 'red', timeout: 6000} , {root:true});
        })
      }
    },
    async updateStudentLMBBulbAttemptCompletion({ rootState, commit }, complete) {
      try {
        const { data: { data: bulbAttempt} } = await axios.patch(`${rootState.nodeApiPrefix}/learner/bulbattempt/update/${rootState.simpleDashData.bulbAttemptId}`,
        {
          complete,
        },
        {
          headers: { 'Authorization':`Bearer ${rootState.learnerData.token}` },
        });
        return bulbAttempt;
      } catch (error) {
        commit('triggerSnackbar', {
          text: 'Error updating student bulb attempt.',
          color: 'error',
        }, { root:true });
      }
    },
    loadBulbAttemptLMB: async ({commit, state, rootState}, data) => {
      try {
        state.learnersAjaxing = true;
        const {
          nodeApiPrefix,
          lti13Launch,
          learnerData: {
            token: learnerToken,
          }
        } = rootState;
        const {
          bulbId,
          sectionId,
          resourceLinkId,
        } = data;
        const lmbAttempt = await axios.get(
          PLAYPOSIT_API_ENDPOINTS.loadBulbAttemptLMB({
            nodeApiPrefix,
            bulbId,
            sectionId,
            resourceLinkId,
            lti13Launch,
          }),
          { 
            headers: {
              'Authorization':`Bearer ${learnerToken}`,
            },
          }
        );
        state.learnersAjaxing = false;
        return lmbAttempt;
      } catch (error) {
        commit('triggerSnackbar', {
          text: 'Error fetching student bulb attempt for LMB.',
          color: 'error',
        }, { root:true });
      }
    }, 
    getPeerReviewAssignments: ({commit, state, rootState}, obj) => { 
      let student_id = _.get(obj, 'student_id', 0)
      const peerReviewGradingEnabled = _.get(obj, 'peerReviewGrading', false);
      // refresh list of peer review bulbs student must take
      // [ ] this will fail if they navigate to a non-LTI peer review monitor page after launching LTI
      const route = `${rootState.nodeApiPrefix}/learner/section/${obj.section_id}/bulb/${obj.bulb_id}/learnerattempts?student_id=${student_id}&peerReviewGrading=${peerReviewGradingEnabled}`;
      // pick correct user token
      const token = ['Admin', 'Instructor'].includes(rootState.primaryAccount) ? rootState.instructorData.token : rootState.learnerData.token;
      axios.get(route, { headers: { 'Authorization':`Bearer ${token}` }})
      .then(res => {
        state.peerReview.give = res.data; // used for learner popover (same data)
        state.peerReviewRubric.give = res.data; // used for instructor slideout (same data)
        if (obj.notification) {
          commit('triggerSnackbar', { text: 'Peer Review Submissions updated', color: 'green', timeout: 6000, aria_live: 'alert' } , {root:true});
        }
      }).catch(err => {
        //if error, log error, trigger snackbar and turn off ajaxing
        dataLayer.axiosLog(err);
        commit('triggerSnackbar', {text:"Peer Review Submissions could not be loaded at this time", color: 'red', timeout: 6000} , {root:true});
      })
    },
    getPeerReviewFeedback: ({commit, state, rootState}, obj) => {
      // refresh list of bulb attempts attached to the active student's current peer_review lmb
      let student_id = _.get(obj, 'student_id', 0);
      //get peer attempts on learner's peer review lmb
      // [ ] this will fail if they navigate to a non-LTI peer review monitor page after launching LTI
      const route = `${rootState.nodeApiPrefix}/learner/section/${obj.section_id}/bulb/${obj.bulb_id}/peerattempts`;
      // pick correct user token
      const token = ['Admin', 'Instructor'].includes(rootState.primaryAccount) ? rootState.instructorData.token : rootState.learnerData.token;
      const params = `?lmb_id=${obj.lmb_id}&lmb_section_id=${obj.lmb_section_id}&anonymous=${obj.anonymous}&rubric=${obj.rubric}&student_id=${student_id}`;
      axios.get(`${route}${params}`, { headers: { 'Authorization':`Bearer ${token}` } } )
      .then(res => {
        //if success, set class search data and turn off ajaxing
        // load discussion into groups
        _.map(res.data.interactions, interaction => {
          if (interaction.interactionType === 'discussion_q') {
             state.peerReview.discussion = { 
              id:interaction.id, 
              text: interaction.interactionText
            };
            state.peerReviewRubric.discussion = { 
              id:interaction.id, 
              text: interaction.interactionText
            };
          }
        });
        // used for learner popover (same data)
        state.peerReview.view = res.data.student;
        state.peerReview.instructor = res.data.teacher;
        state.peerReview.interactions = res.data.interactions;
        // used for instructor slideout (same data)
        state.peerReviewRubric.view = res.data.student;
        state.peerReviewRubric.instructor = res.data.teacher;
        state.peerReviewRubric.interactions = res.data.interactions;
        if (obj.notification) {
          commit('triggerSnackbar', { text: 'Peer Review Feedback updated', color: 'green', timeout: 6000, aria_live: 'alert' } , {root:true});
        }
      }).catch(err => {
        // If error, log error, trigger snackbar and turn off ajaxing
        dataLayer.axiosLog(err);
        if (_.get(err, 'response.data.message', '') === 'invalid_group') {
          commit('triggerSnackbar', {
            text:`This submission cannot be evaluated until the learner is added to a group.`,
            color: 'red',
            timeout: 6000,
            action: (rootState.LMSdata.type === 'Canvas' || obj?.inCanvasLMS) ? 'groupsPeerReviewCanvas' : 'groupsPeerReviewPlayPosit',
            action_text: 'Groups',
          } , {
            root: true,
          });
        } else {
          commit('triggerSnackbar', {
            text: 'Peer Review Feedback cannot be loaded at this time',
            color: 'red',
            timeout: 6000,
          } , {
            root: true,
          });
        }
      });
    },
};

const getters = {
    activeViewLearners: state => state.activeViewLearners,
    learnersAjaxing: state => state.learnersAjaxing,
    queryParamsLearners: state => state.queryParamsLearners,
    learnerDataLoaded: state => state.learnerDataLoaded,
    classes: state => state.classes,
    selectedData: state => state.selectedData,
    bulbs: state => state.bulbs,
    gradebook: state => state.gradebook,
    learnerGradebookBreadcrumbs: state => state.learnerGradebookBreadcrumbs,
    studentinteraction: state => state.studentinteraction,
    refreshData: state => state.refreshData,
    classSearch: state => state.classSearch,
    classPicker: state => state.classPicker,
    lmb: state => state.lmb,
    peerReview: state => state.peerReview,
    peerReviewRubric: state => state.peerReviewRubric,
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}